import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
import { getPreviewMiddleware, setPreviewCacheHeader } from './utils';
async function load(app) {
  app.addMiddleware(getPreviewMiddleware(app));
  setPreviewCacheHeader(app);
  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}
load.pluginName = PLUGIN_NAME;
export default load;
//# sourceMappingURL=index.js.map